/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import AudioManager from '../Audio/AudioManager';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import CLog, { LogTypes } from '../Utility/ComponentLogger';
import Effect from './Effect';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Triggers an audio cue on the [[AudioManager]]. */
@cc._decorator.ccclass
export default class AudioEffect extends Effect
{
    /** The cue to trigger. */
    @property({ visible: true })
    private _cue: string = "";

    /** Whether the cue should be played or stopped. */
    @property({ visible: true })
    private _stopSound: boolean = false;

    /** @hidden */
    private _audioManagerRef: InjectableComponent<AudioManager> = new InjectableComponent();

    /** @hidden */
    protected setContexts(): void
    {
        this._audioManagerRef.SetContext(AudioManager);
    }

    /** Activates the effect. */
    protected trigger = (): void =>
    {
        this._audioManagerRef.WithValue(audioManager =>
            {
                this._stopSound
                    ? audioManager.StopTrigger(null, this._cue)
                    : audioManager.TriggerSound(null, this._cue);
            },
            () => CLog.warn("Cannot trigger sound, AudioManager null or undefined.", LogTypes.Audio));
    }

    /** @hidden */
    protected update(dt: number): void
    {
        super.update(dt);

        if (!this.IsCurrentState()) { return; }
        this.complete();
    }
}
